import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { ref: "searchResultsRef" }
const _hoisted_2 = {
  key: 1,
  id: "copilot-entry-point-a"
}
const _hoisted_3 = {
  key: 3,
  id: "copilot-entry-point-b"
}
const _hoisted_4 = {
  key: 3,
  class: "NoResultsWrapper"
}
const _hoisted_5 = {
  key: 4,
  class: "LoaderContainer LoadingStatus"
}
const _hoisted_6 = { key: 5 }
const _hoisted_7 = { class: "PagNavigationContainer" }
const _hoisted_8 = ["rel", "href"]
const _hoisted_9 = { class: "SeeMoreLabelVar1" }
const _hoisted_10 = ["rel", "href"]
const _hoisted_11 = {
  key: 0,
  class: "FaqContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeoStructuredData = _resolveComponent("SeoStructuredData")!
  const _component_KeywordHelper = _resolveComponent("KeywordHelper")!
  const _component_StudyCard = _resolveComponent("StudyCard")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_BannerCluster = _resolveComponent("BannerCluster")!
  const _component_NoResultsRecommendations = _resolveComponent("NoResultsRecommendations")!
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_Faq = _resolveComponent("Faq")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.applicationStatusReady && _ctx.currentPageNumber === 1)
      ? (_openBlock(), _createBlock(_component_SeoStructuredData, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.currentPostHogExperiment === _ctx.postHogExperimentValues.SOPHIA_ENTRY_POINT_VARIANT_A)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("v-if", true),
    (_ctx.showSearchHelper)
      ? (_openBlock(), _createBlock(_component_KeywordHelper, {
          key: 2,
          onDismissHelper: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSearchHelper = false))
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("ul", {
      class: _normalizeClass(["SearchResultsList", { Hidden: !_ctx.applicationStatusReady }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(["SearchResultItem", { BeforeReady: !_ctx.applicationStatusReady }]),
          "data-cy": "SearchResultItem"
        }, [
          (_ctx.isSearchCard(item))
            ? (_openBlock(), _createBlock(_component_StudyCard, {
                key: item.id,
                presentationStudyCardInfo: item,
                class: "HoverEffect"
              }, null, 8 /* PROPS */, ["presentationStudyCardInfo"]))
            : (_ctx.isSingleBanner(item))
              ? (_openBlock(), _createBlock(_component_Banner, {
                  key: 1,
                  containerId: item.containerId,
                  type: item.type,
                  cssClass: item.cssClass
                }, null, 8 /* PROPS */, ["containerId", "type", "cssClass"]))
              : (_ctx.isBannerCluster(item))
                ? (_openBlock(), _createBlock(_component_BannerCluster, {
                    key: 2,
                    bannerIds: item.bannerIds,
                    type: item.type,
                    cssClass: item.cssClass
                  }, null, 8 /* PROPS */, ["bannerIds", "type", "cssClass"]))
                : _createCommentVNode("v-if", true),
          (index === 10 && _ctx.currentPostHogExperiment === _ctx.postHogExperimentValues.SOPHIA_ENTRY_POINT_VARIANT_B)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */),
    (_ctx.showRecommendations)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_NoResultsRecommendations)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_PreLoader, { label: "Loading..." })
        ]))
      : _createCommentVNode("v-if", true),
    (!_ctx.noSearchResults && _ctx.applicationStatusReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("nav", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onclickPreviousButton()), ["prevent"])),
              class: _normalizeClass(["PreviousButton NavigatorButton", { Disabled: _ctx.currentPageNumber === 1 }]),
              "aria-label": "Previous page",
              title: "Previous page",
              rel: 
						_ctx.currentPageNumber === 1 || _ctx.currentPageNumber > 2
						? 'nofollow'
						: 'prev',
              href: _ctx.previousPageHref
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "ChevronLeft lnr-chevron-left" }, null, -1 /* CACHED */),
              _createTextVNode(),
              _createElementVNode("span", null, "Previous", -1 /* CACHED */)
            ]), 10 /* CLASS, PROPS */, _hoisted_8),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.currentPageNumber) + " of " + _toDisplayString(_ctx.totalPages), 1 /* TEXT */),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onclickNextButton()), ["prevent"])),
              class: _normalizeClass(["NextButton NavigatorButton", { Disabled: _ctx.isLastPage }]),
              "aria-label": "Next page",
              title: "Next page",
              rel: 
						_ctx.isLastPage || _ctx.currentPageNumber > 1
						? 'nofollow'
						: 'next',
              href: _ctx.nextPageHref
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("span", null, "Next", -1 /* CACHED */),
              _createTextVNode(),
              _createElementVNode("i", { class: "ChevronRight lnr-chevron-right" }, null, -1 /* CACHED */)
            ]), 10 /* CLASS, PROPS */, _hoisted_10)
          ]),
          (_ctx.isPortalTypeMasters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_Faq)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}